// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2578":"30a9c875052e1774","3252":"17dbf08f0d084912","4702":"55c47619e5bffb4d"}[chunkId] + ".js";
};